import { Currency } from '../../currency/objects/currency';
import { CustomProvider } from '../../customProvider/objects/customProvider';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { Event } from '../../event/objects/event';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Preferences } from '../../profile/objects/preferences';
import { AutomaticProduct } from '../objects/automaticProduct';
import { Column } from '../objects/column';
import { Error } from '../objects/error';
import { List } from '../objects/list';

export const ADD_PREFERENCES = 'AUTOMATIC_PRODUCT_ADD_PREFERENCES';
export const ADD_COUNTRY_PRICE = 'AUTOMATIC_PRODUCT_ADD_COUNTRY_PRICE';
export const DELETE_COUNTRY_PRICE = 'AUTOMATIC_PRODUCT_DELETE_COUNTRY_PRICE';
export const DELETE_PICTURE = 'AUTOMATIC_PRODUCT_DELETE_PICTURE';
export const MOVE_DOWN_COLUMN = 'AUTOMATIC_PRODUCT_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'AUTOMATIC_PRODUCT_MOVE_UP_COLUMN';
export const RESET_ADD_PRODUCT = 'AUTOMATIC_PRODUCT_RESET_ADD_PRODUCT';
export const RESET_FILTERS = 'AUTOMATIC_PRODUCT_RESET_FILTERS';
export const SET_AUTOMATIC_PRODUCT_DELETE = 'AUTOMATIC_PRODUCT_SET_AUTOMATIC_PRODUCT_DELETE';
export const SET_AUTOMATIC_PRODUCT_DUPLICATE = 'AUTOMATIC_PRODUCT_SET_AUTOMATIC_RODUCT_DUPLICATE';
export const SET_EDIT_STEP = 'AUTOMATIC_PRODUCT_SET_EDIT_STEP';
export const SET_ERRORS = 'AUTOMATIC_PRODUCT_SET_ERRORS';
export const SET_EXPORT_TYPE = 'AUTOMATIC_PRODUCT_SET_EXPORT_TYPE';
export const SET_LIMIT = 'AUTOMATIC_PRODUCT_SET_LIMIT';
export const SET_LIST = 'AUTOMATIC_PRODUCT_SET_LIST';
export const SET_ORDER_BY = 'AUTOMATIC_PRODUCT_SET_ORDER_BY';
export const SET_PAGE = 'AUTOMATIC_PRODUCT_SET_PAGE';
export const SET_PREFERENCES = 'AUTOMATIC_PRODUCT_SET_PREFERENCES';
export const SET_PRODUCT = 'AUTOMATIC_PRODUCT_SET_PRODUCT';
export const SET_RUNNING = 'AUTOMATIC_PRODUCT_SET_RUNNING';
export const SET_SEARCH = 'AUTOMATIC_PRODUCT_SET_SEARCH';
export const SET_COLUMNS = 'AUTOMATIC_PRODUCT_SET_COLUMNS';
export const RESIZE_COLUMN = 'AUTOMATIC_PRODUCT_RESIZE_COLUMN';
export const TOGGLE_CANCEL_MODAL = 'AUTOMATIC_PRODUCT_TOGGLE_CANCEL_MODAL';
export const TOGGLE_COLUMN = 'AUTOMATIC_PRODUCT_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'AUTOMATIC_PRODUCT_TOGGLE_CREATE';
export const TOGGLE_EXPORT = 'AUTOMATIC_PRODUCT_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'AUTOMATIC_PRODUCT_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'AUTOMATIC_PRODUCT_TOGGLE_FILTERS';
export const TOGGLE_PICTURES_ORDER = 'AUTOMATIC_PRODUCT_TOGGLE_PICTURES_ORDER';
export const TOGGLE_REFRESH = 'AUTOMATIC_PRODUCT_TOGGLE_REFRESH';
export const UPDATE_AGENCY_CREATOR_ONLY = 'AUTOMATIC_PRODUCT_UPDATE_UPDATE_AGENCY_CREATOR_ONLY';
export const UPDATE_ALLOWED_DESTINATION = 'AUTOMATIC_PRODUCT_UPDATE_UPDATE_ALLOWED_DESTINATION';
export const UPDATE_CURRENCY = 'AUTOMATIC_PRODUCT_UPDATE_UPDATE_CURRENCY';
export const UPDATE_DESCRIPTION_LOCALE = 'AUTOMATIC_PRODUCT_UPDATE_UPDATE_DESCRIPTION_LOCALE';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'DESTINATION_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_DESTINATION = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_DESTINATION';
export const UPDATE_FILTER_EVENT = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_EVENT';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_LAST_AUTHOR = 'DESTINATION_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_PERIOD = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'AUTOMATIC_PRODUCT_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FIX_TRIP_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_FIX_TRIP_PRICE';
export const UPDATE_FIX_TRIP_PAX_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_FIX_TRIP_PAX_PRICE';
export const UPDATE_HAS_DELETION_RESTRICTION = 'AUTOMATIC_UPDATE_HAS_DELETION_RESTRICTION';
export const UPDATE_IATA_COUNTRIES = 'AUTOMATIC_PRODUCT_UPDATE_IATA_COUNTRIES';
export const UPDATE_IS_BOOKABLE = 'AUTOMATIC_PRODUCT_UPDATE_IS_BOOKABLE';
export const UPDATE_IS_DISPLAYED = 'AUTOMATIC_PRODUCT_UPDATE_IS_DISPLAYED';
export const UPDATE_IS_PRICE_EDITABLE = 'AUTOMATIC_UPDATE_IS_PRICE_EDITABLE';
export const UPDATE_IS_PRICE_EDITABLE_SELLER = 'AUTOMATIC_UPDATE_IS_PRICE_EDITABLE_SELLER';
export const UPDATE_IS_OPTIONAL = 'AUTOMATIC_PRODUCT_UPDATE_IS_OPTIONAL';
export const UPDATE_IS_HIDDEN_FOR_TRAVELERS = 'AUTOMATIC_PRODUCT_UPDATE_IS_HIDDEN_FOR_TRAVELERS';
export const UPDATE_IS_MARGIN_EDITABLE_BY_AGENCY = 'AUTOMATIC_PRODUCT_UPDATE_IS_MARGIN_EDITABLE_BY_AGENCY';
export const UPDATE_IS_SURCOM_APPLICABLE = 'AUTOMATIC_PRODUCT_UPDATE_IS_SURCOM_APPLICABLE';
export const UPDATE_IS_SURCOM_ONLY = 'AUTOMATIC_PRODUCT_UPDATE_IS_SURCOM_ONLY';
export const UPDATE_IS_PRICE_PER_DAY = 'AUTOMATIC_PRODUCT_UPDATE_IS_PRICE_PER_DAY';
export const UPDATE_IS_PRICE_PER_PAX = 'AUTOMATIC_PRODUCT_UPDATE_IS_PRICE_PER_PAX';
export const UPDATE_IS_PRICE_PER_ROOM = 'AUTOMATIC_PRODUCT_UPDATE_IS_PRICE_PER_ROOM';
export const UPDATE_LIST_ITEM_ACTIVATION = 'AUTOMATIC_UPDATE_LIST_ITEM_ACTIVATION';
export const UPDATE_MAX_TRIP_PAX_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_MAX_TRIP_PAX_PRICE';
export const UPDATE_MAX_TRIP_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_MAX_TRIP_PRICE';
export const UPDATE_MIN_TRIP_PAX_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_MIN_TRIP_PAX_PRICE';
export const UPDATE_MIN_TRIP_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_MIN_TRIP_PRICE';
export const UPDATE_NAME_LOCALE = 'AUTOMATIC_PRODUCT_UPDATE_NAME_LOCALE';
export const UPDATE_NO_AUTO_ADD = 'AUTOMATIC_PRODUCT_UPDATE_NO_AUTO_ADD';
export const UPDATE_PICTURE_ORDER = 'AUTOMATIC_PRODUCT_UPDATE_PICTURE_ORDER';
export const UPDATE_PRICE_TYPE = 'AUTOMATIC_PRODUCT_UPDATE_PRICE_TYPE';
export const UPDATE_PRODUCT_CODE = 'AUTOMATIC_PRODUCT_UPDATE_PRODUCT_CODE';
export const UPDATE_PRODUCT_TYPE = 'AUTOMATIC_PRODUCT_UPDATE_PRODUCT_TYPE';
export const UPDATE_PROVIDER = 'AUTOMATIC_PRODUCT_UPDATE_PROVIDER';
export const UPDATE_PROVIDER_NAME = 'AUTOMATIC_PRODUCT_UPDATE_PROVIDER_NAME';
export const UPDATE_PURCHASE_CURRENCY = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_CURRENCY';
export const UPDATE_PURCHASE_CURRENCY_COUNTRY = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_CURRENCY_COUNTRY';
export const UPDATE_EVENT_SITES = 'AUTOMATIC_PRODUCT_UPDATE_EVENT_SITES';
export const UPDATE_PURCHASE_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_PRICE';
export const UPDATE_PURCHASE_PRICE_COUNTRY = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_PRICE_COUNTRY';
export const UPDATE_SELLING_PRICE = 'AUTOMATIC_PRODUCT_UPDATE_SELLING_PRICE';
export const UPDATE_SELLING_PRICE_COUNTRY = 'AUTOMATIC_PRODUCT_UPDATE_SELLING_PRICE_COUNTRY';
export const UPDATE_TVA_PERCENTAGE = 'AUTOMATIC_PRODUCT_UPDATE_TVA_PERCENTAGE';
export const UPDATE_TVA_PERCENTAGE_COUNTRY = 'AUTOMATIC_PRODUCT_UPDATE_TVA_PERCENTAGE_COUNTRY';
export const UPDATE_SELLING_PRICE_PERCENTAGE = 'AUTOMATIC_PRODUCT_UPDATE_SELLING_PRICE_PERCENTAGE';
export const UPDATE_SELLING_PRICE_TYPE = 'AUTOMATIC_PRODUCT_UPDATE_SELLING_PRICE_TYPE';
export const UPDATE_PURCHASE_PRICE_PERCENTAGE = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_PRICE_PERCENTAGE';
export const UPDATE_PURCHASE_PRICE_TYPE = 'AUTOMATIC_PRODUCT_UPDATE_PURCHASE_PRICE_TYPE';
export const UPDATE_TO_CREATOR_ONLY = 'AUTOMATIC_PRODUCT_UPDATE_TO_CREATOR_ONLY';

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface AddCountryPriceAction {
    type: typeof ADD_COUNTRY_PRICE,
}

interface DeleteCountryPriceAction {
    type: typeof DELETE_COUNTRY_PRICE,
    payload: number
}

interface DeletePictureAction {
    type: typeof DELETE_PICTURE,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetAddProductAction {
    type: typeof RESET_ADD_PRODUCT
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetAutomaticProductDeleteAction {
    type: typeof SET_AUTOMATIC_PRODUCT_DELETE,
    payload: null | false | AutomaticProduct
}

interface SetAutomaticProductDuplicate {
    type: typeof SET_AUTOMATIC_PRODUCT_DUPLICATE,
    payload: null | AutomaticProduct,
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: string | null
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface SetColumnAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetProductAction {
    type: typeof SET_PRODUCT,
    payload: AutomaticProduct
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}
interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}
interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface TogglePicturesOrderAction {
    type: typeof TOGGLE_PICTURES_ORDER,
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateAgencyCreatorOnlyleAction {
    type: typeof UPDATE_AGENCY_CREATOR_ONLY,
}

interface UpdateAllowedDestinationAction {
    type: typeof UPDATE_ALLOWED_DESTINATION,
    payload: DestinationReduced[]
}

interface UpdateCurrencyAction {
    type: typeof UPDATE_CURRENCY,
    payload: Currency | null
}

interface UpdateDescriptionLocaleAction {
    type: typeof UPDATE_DESCRIPTION_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterDestinationAction {
    type: typeof UPDATE_FILTER_DESTINATION,
    payload: null | DestinationReduced
}

interface UpdateFilterEventAction {
    type: typeof UPDATE_FILTER_EVENT,
    payload: null | Event
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFixTripPriceAction {
    type: typeof UPDATE_FIX_TRIP_PRICE,
    payload: string
}

interface UpdateFixTripPricePaxAction {
    type: typeof UPDATE_FIX_TRIP_PAX_PRICE,
    payload: string
}

interface UpdateHasDeletionRestrictionAction {
    type: typeof UPDATE_HAS_DELETION_RESTRICTION
}

interface updateIataCountriesAction {
    type: typeof UPDATE_IATA_COUNTRIES,
    payload: {
        value: IataCountry[],
        index: number
    }
}

interface UpdateIsBookableAction {
    type: typeof UPDATE_IS_BOOKABLE
}

interface UpdateIsDisplayedAction {
    type: typeof UPDATE_IS_DISPLAYED
}

interface UpdateIsPriceEditableAction {
    type: typeof UPDATE_IS_PRICE_EDITABLE
}

interface UpdateIsPriceEditableSellerAction {
    type: typeof UPDATE_IS_PRICE_EDITABLE_SELLER
}

interface UpdateIsOptionalAction {
    type: typeof UPDATE_IS_OPTIONAL
}

interface UpdateIsHiddenForTravelersAction {
    type: typeof UPDATE_IS_HIDDEN_FOR_TRAVELERS
}

interface UpdateIsMarginEditalbeByAgencyAction {
    type: typeof UPDATE_IS_MARGIN_EDITABLE_BY_AGENCY
}

interface UpdateIsSurcomApplicableAction {
    type: typeof UPDATE_IS_SURCOM_APPLICABLE
}

interface UpdateIsSurcomOnlyAction {
    type: typeof UPDATE_IS_SURCOM_ONLY
}

interface UpdateIsPricePerDayAction {
    type: typeof UPDATE_IS_PRICE_PER_DAY
}

interface UpdateIsPricePerPaxAction {
    type: typeof UPDATE_IS_PRICE_PER_PAX
}

interface UpdateIsPricePerRoomAction {
    type: typeof UPDATE_IS_PRICE_PER_ROOM
}

interface UpdateListItemActivationAction {
    type: typeof UPDATE_LIST_ITEM_ACTIVATION,
    payload: AutomaticProduct
}

interface UpdateMaxTripPriceAction {
    type: typeof UPDATE_MAX_TRIP_PRICE,
    payload: string
}

interface UpdateMaxTripPricePaxAction {
    type: typeof UPDATE_MAX_TRIP_PAX_PRICE,
    payload: string
}

interface UpdateMinTripPriceAction {
    type: typeof UPDATE_MIN_TRIP_PRICE,
    payload: string
}

interface UpdateMinTripPricePaxAction {
    type: typeof UPDATE_MIN_TRIP_PAX_PRICE,
    payload: string
}

interface UpdateNameLocalAction {
    type: typeof UPDATE_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateNoAutoAddAction {
    type: typeof UPDATE_NO_AUTO_ADD,
}

interface UpdatePictureOrderAction {
    type: typeof UPDATE_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface UpdatePriceTypeAction {
    type: typeof UPDATE_PRICE_TYPE,
    payload: string
}

interface UpdateProductCodeAction {
    type: typeof UPDATE_PRODUCT_CODE,
    payload: string
}

interface UpdateProductTypeAction {
    type: typeof UPDATE_PRODUCT_TYPE,
    payload: string
}

interface UpdateProviderAction {
    type: typeof UPDATE_PROVIDER,
    payload: null | CustomProvider
}

interface UpdateProviderNameAction {
    type: typeof UPDATE_PROVIDER_NAME,
    payload: string
}

interface UpdatePurchaseCurrencyAction {
    type: typeof UPDATE_PURCHASE_CURRENCY,
    payload: Currency | null
}

interface UpdatePurchaseCurrencyCountryAction {
    type: typeof UPDATE_PURCHASE_CURRENCY_COUNTRY,
    payload: {
        value: Currency | null,
        index: number | null
    }
}

interface UpdateEventSitesAction {
    type: typeof UPDATE_EVENT_SITES,
    payload: Event[]
}

interface UpdatePurchasePriceAction {
    type: typeof UPDATE_PURCHASE_PRICE,
    payload: string | number
}


interface UpdatePurchasePriceCountryAction {
    type: typeof UPDATE_PURCHASE_PRICE_COUNTRY,
    payload: {
        value: string | number,
        index: number | null
    }
}
interface UpdateSellingPriceCountryAction {
    type: typeof UPDATE_SELLING_PRICE_COUNTRY,
    payload: {
        value: string | number,
        index: number | null
    }
}

interface UpdateSellingPriceAction {
    type: typeof UPDATE_SELLING_PRICE,
    payload: string | number
}

interface UpdateTvaPercentageCountryAction {
    type: typeof UPDATE_TVA_PERCENTAGE_COUNTRY,
    payload: {
        value: string | number,
        index: number | null
    }
}

interface UpdateTvaPercentageAction {
    type: typeof UPDATE_TVA_PERCENTAGE,
    payload: string | number
}

interface UpdateSellingPricePercentageAction {
    type: typeof UPDATE_SELLING_PRICE_PERCENTAGE,
    payload: string | number
}
interface UpdateSellingPriceTypeAction {
    type: typeof UPDATE_SELLING_PRICE_TYPE,
    payload: 'FIX' | 'PER'
}
interface UpdatePurchasePricePercentageAction {
    type: typeof UPDATE_PURCHASE_PRICE_PERCENTAGE,
    payload: string | number
}
interface UpdatePurchasePriceTypeAction {
    type: typeof UPDATE_PURCHASE_PRICE_TYPE,
    payload: 'FIX' | 'PER'
}

interface UpdateToCreatorOnlyAction {
    type: typeof UPDATE_TO_CREATOR_ONLY
}

export type AutomaticProductActionTypes =
    AddCountryPriceAction |
    AddPreferencesAction |
    DeleteCountryPriceAction |
    DeletePictureAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetAddProductAction |
    ResetFiltersAction |
    SetAutomaticProductDeleteAction |
    SetAutomaticProductDuplicate |
    SetEditStepAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetColumnAction |
    ResizeColumnAction |
    SetPageAction |
    SetPreferencesAction |
    SetProductAction |
    SetRunningAction |
    SetSearchAction |
    ToggleCancelModalAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleNewAction |
    TogglePicturesOrderAction |
    ToggleRefreshAction |
    UpdateAgencyCreatorOnlyleAction |
    UpdateAllowedDestinationAction |
    UpdateCurrencyAction |
    UpdateDescriptionLocaleAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterDestinationAction |
    UpdateFilterEventAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFixTripPriceAction |
    UpdateFixTripPricePaxAction |
    UpdateHasDeletionRestrictionAction |
    UpdateIsBookableAction |
    UpdateIsDisplayedAction |
    UpdateIsHiddenForTravelersAction |
    UpdateIsMarginEditalbeByAgencyAction |
    UpdateIsOptionalAction |
    UpdateIsPriceEditableAction |
    UpdateIsPriceEditableSellerAction |
    UpdateIsPricePerDayAction |
    UpdateIsPricePerPaxAction |
    UpdateIsPricePerRoomAction |
    UpdateIsSurcomApplicableAction |
    UpdateIsSurcomOnlyAction |
    UpdateListItemActivationAction |
    UpdateMaxTripPriceAction |
    UpdateMaxTripPricePaxAction |
    UpdateMinTripPriceAction |
    UpdateMinTripPricePaxAction |
    UpdateNameLocalAction |
    UpdateNoAutoAddAction |
    UpdatePictureOrderAction |
    UpdatePriceTypeAction |
    UpdateProductCodeAction |
    UpdateProductTypeAction |
    UpdateProviderAction |
    UpdateProviderNameAction |
    UpdatePurchaseCurrencyAction |
    UpdatePurchaseCurrencyCountryAction |
    UpdateEventSitesAction |
    UpdatePurchasePriceAction |
    UpdatePurchasePriceCountryAction |
    UpdateSellingPriceAction |
    UpdateSellingPriceCountryAction |
    UpdateTvaPercentageCountryAction |
    UpdateTvaPercentageAction |
    UpdateSellingPricePercentageAction |
    UpdateSellingPriceTypeAction |
    UpdatePurchasePricePercentageAction |
    UpdatePurchasePriceTypeAction |
    UpdateToCreatorOnlyAction |
    updateIataCountriesAction;